export const constant = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  WHATSAPP_TOKEN:
    'EAARdrS5aDu8BO6Boj1BTznkr2isfTBSFqO53LvS0GPAtpn7Q0r8oRPk6T0lTNetGKeEoAfZBfDUIcgKwBv2gN1Ld3ejJmZCXM1ANSrf1DTU0VYXWd7hfeYfQ2LLrsj5PPXQjZBeD29mA7TS1pZCbtKHZB8ka9ObQRAqouJP4y1MA84HI3gzH1VUNZCZBybgtATCIQZDZD',
  WHATSAPP_MESSAGE_URL: 'https://graph.facebook.com/v19.0/381472345039573/messages'
};
